module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms2_jp.0c3ec4f13e307d67306a7a9e446bdff1.png";